import React, { useState, useEffect, useRef } from "react";
import {
  BarChart3,
  Plus,
  FileText,
  Users,
  TrendingUp,
  CreditCard,
  ChevronDown,
  ChevronRight,
  Settings,
} from "lucide-react";
// import logo from "../../asset/navbar/logo.svg";
import logo from "../../asset/navbar/logoJobizo.svg";
import user from "../../asset/navbar/user.svg";
import downArrow from "../../asset/sidebar/arrowdown.svg";
import whiteArrow from "../../asset/sidebar/whiteArrow.svg";
import { Modal } from "@mui/material";
import PostingJobModal from "../Dashboard/JobPost/PostingModal";
import LogoutConfirmation from "../PopUp/LogoutConfirmation/LogoutConfirmation";
import signOut from "../../asset/dashboard/signOut.svg";
import profileIcon from "../../asset/dashboard/profileIcon.svg";
import commentIcon from "../../asset/dashboard/commentbox.jpg";
import dropdownStick from "../../asset/jobs/dropdownStick.svg";
import { motion } from "framer-motion";
import {
  setActiveTab,
  setJobPostedReducer,
  setModel,
} from "../../redux/userReducer";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import graphqlRequest from "../../requestMethod";
import JobShiftPostDetails from "./../PopUp/JobShiftPostDetails/JobShiftPostDetails";
import { setJobModal, setJobDetaialsModal } from "../../redux/userReducer";

import "./SidebarNew.scss";
import { pushEvent } from "../../utils/clevertap";

function SidebarNew({ locumHoursData, hasUnsavedChanges  , onClose}) {
  let {
    activeTab,
    reduxLocumToggle,
    reduxLocumJobActiveTab,
    reduxLocumReportToggle,
    reduxLocumReportActiveTab,
  } = useSelector((state) => state.user);
  let dispatch = useDispatch();
  const dropdownRef = useRef();
const location = useLocation();
  let [selectedData, setSelectedData] = useState({});

  const handleCloseDetail = () => dispatch(setJobDetaialsModal());
  const [active, setActive] = useState(activeTab);

  const [LocumJobToggle, setLocumJobToggle] = useState(reduxLocumToggle);
  const [locumActive, setLocumActive] = useState(reduxLocumJobActiveTab);
  const [LocumReportToggle, setLocumReportToggle] = useState(false);
  const [locumReportActive, setLocumReportActive] = useState(0);

  const [permanentActive, setPermanentActive] = useState(0);
  const [PermanentJobToggle, setPermanentJobToggle] = useState(false);
  const [PermanentReportToggle, setPermanentReportToggle] = useState(false);

  const [userActive, setUserActive] = useState(0);
  const [userToggle, setUserToggle] = useState(false);

  const [billingToogle, setBillingToggle] = useState(false);
  const [billingActive, setBillingActive] = useState(0);
  const [isUpcomingOpen, setIsUpcomingOpen] = useState(false);

  //JOB POSTED STATUS
  const { postingJob } = useSelector((state) => state.user);
  // const [postingJOb, setPostingJob] = useState(false);
  const [disacardPostingJob, setDisacardPostingJob] = useState(false);
  const [discardPostingJob, setDiscardPostingJob] = useState(false);
  const [jobsExpanded, setJobsExpanded] = useState(false);
  const [usersExpanded, setUsersExpanded] = useState(false);
  const [userData, setUserData] = useState();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showQueryModal, setShowQueryModal] = useState(false);
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isLogoutConfirmationOpen, setIsLogoutConfirmationOpen] =
    useState(false);
  const [openPostAJob, setOpenPostAJob] = useState(false);

  let data = localStorage.getItem("auth");
  let token = JSON.parse(data)?.accessToken;

  const navigate = useNavigate();
  const handleChange = (index) => {
    console.log("index", index);
    dispatch(setActiveTab({ index }));
    setActive(index);
    setLocumJobToggle(false);
    setLocumActive(0);
    setPermanentActive(0);
    setPermanentJobToggle(false);
    setUserToggle(false);
    setUserActive(0);
  };

  const HandleLocumJobActiveTab = (index, locumActive) => {
    setLocumActive(locumActive);
    dispatch(
      setActiveTab({ index, LocumJobToggle: LocumJobToggle, locumActive })
    );
    setLocumReportToggle(false);
    setLocumReportActive(0);
  };

  const handleLocumReportToggle = () => {
    setLocumReportToggle(!LocumReportToggle);
    dispatch(
      setActiveTab({
        index: activeTab,
        LocumJobToggle: true,
        locumActive: locumActive,
        LocumReportToggle: !LocumReportToggle,
        locumReportActive: locumReportActive,
      })
    );
  };

  //calling redux reducer when we click on locum report dropdown
  const handleLocumReportActive = (locumreportindex) => {
    setLocumReportActive(locumreportindex);
    setLocumActive(0);

    dispatch(
      setActiveTab({
        index: activeTab,
        LocumJobToggle: true,
        locumActive: 0,
        LocumReportToggle: LocumReportToggle,
        locumReportActive: locumreportindex,
      })
    );
  };

  const handleWriteToUsClick = () => {
    setShowQueryModal(true);
    // Check if setShowQueryModal is updating the state correctly
    console.log("Show Query Modal:", showQueryModal);
  };

  const setPostingJob = () => {
    dispatch(setJobPostedReducer());
  };

  let navigateToProfile = () => {
    setIsSidebarOpen(!isSidebarOpen);
    pushEvent("Web_Profile_View", {
      page: "Sidebar",
      section: "Profile",
    });
    navigate("/user-profile");
  };

  let fetchUserDetails = () => {
    const query = `
            query {
              withAuth(token: "${token}") {
                  userDetails {
                      id
                      marksPercentage
                      avatar{
                        url
                      }
                      name{
                        first
                        full
                      }
                      organizations{
                        organization{
                          id
                          companies{
                            id
                            name
                            logo{
                              url
                            }
                          }
                          name
                          
                        }
                        role{
                          id
                          name
                        }
                      }
                  }
              }   
          }
            `;

    graphqlRequest(query).then((response) => {
      setUserData(response?.data?.withAuth);
      // if (response?.errors) {
      //   message?.error("Already invited!");
      // }
      // else if (response?.data?.withAuth?.inviteUser) {
      //   message?.success("Email has been sent");
      // }
    });
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function handleLogout() {
     pushEvent("Web_User_LoggedOut", {
              page: "Auth",
              section: "Auth",
            });
    dispatch(setActiveTab(1));
    localStorage.removeItem("auth");
    window.location.reload();
    window.clevertap?.clear();
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
    navigate("/home");
  }

  const upcomingJobs = localStorage.getItem("upcomingJobsThisWeekCount");
  const openJobs = localStorage.getItem("openJobsCount");
  const completedJobs = localStorage.getItem("completedJobsCount");

  console.log("postingJob", postingJob);
  console.log("disacardPostingJob", disacardPostingJob);
  console.log("discardPostingJob", discardPostingJob);
  console.log("openPostAJob", openPostAJob);
  const trackOpenJob = () => {
    pushEvent("Web_Open_Job", {
      page: "Sidebar",
      section: "Jobs",
    });
  };
  const trackAcceptedJob = () => {
    pushEvent("Web_Accepted_Job", {
      page: "Sidebar",
      section: "Jobs",
    });
  };
  const trackOngoingJob = () => {
    pushEvent("Web_Ongoing_Job", {
      page: "Sidebar",
      section: "Jobs",
    });
  };
  const trackCompletedJob = () => {
    pushEvent("Web_Completed_Job", {
      page: "Sidebar",
      section: "Jobs",
    });
  };
  const trackCancelledJob = () => {
    pushEvent("Web_Cancelled_Job", {
      page: "Sidebar",
      section: "Jobs",
    });
  };
  const trackShiftlogJob = () => {
    pushEvent("Web_ShiftLogs_Job", {
      page: "Sidebar",
      section: "Jobs",
    });
  };

  return (
    <div className="sidebar-container">
      <div className="sidebar">
        <div className="sidebar-header">
          {/* <h1 className="logo-text">JOBIZO</h1> */}
          <img className="logo-img" src={logo} alt="jobizo-logo" />
        </div>

        <div className="sidebar-divider">
          <div className="sidebar-menu">
            <Link to={postingJob ? "/locum-job" : "/"}>
              <div
                // className="menu-item"
                className={`menu-item ${
                  location.pathname === "/" ? "active" : ""
                }`}
                onClick={() => {
                  pushEvent("Web_Dashboard", {
                    page: "Sidebar",
                    section: "Dashboard",
                  });
                  postingJob ? setDisacardPostingJob(true) : handleChange(1);
                  if (onClose) onClose();
                }}
              >
                <div className="icon-wrapper">
                  <BarChart3 size={16} color="#ffffff" />
                </div>
                <span>Dashboard</span>
              </div>
            </Link>

            <div
              // className="menu-item accent"
              className={`menu-item ${
                location.pathname === "/locum-job" ? "active" : ""
              } accent`}
              onClick={() => {
                pushEvent("Web_Intialize_Job_Post", {
                  page: "Sidebar",
                  section: "Job Post",
                });
                setOpenPostAJob(true);
                // postingJob ? setDiscardPostingJob(true) : dispatch(setModel());
                postingJob
                  ? setDiscardPostingJob(true)
                  : navigate("/locum-job");
                  if (onClose) onClose();
                // navigate("/locum-job");
              }}
            >
              <div className="icon-wrapper">
                <Plus size={16} />
              </div>
              <span>Post a Job</span>
            </div>

            <div
              // className="menu-item"
              className={`menu-item ${jobsExpanded ? "active" : ""}`}
              // onClick={() => setJobsExpanded(!jobsExpanded)}
              onClick={() => {
                const willCollapse = jobsExpanded;
                setJobsExpanded(!jobsExpanded);
                if (willCollapse) setLocumReportToggle(false);
              }}
            >
              <div className="icon-wrapper">
                <FileText size={16} color="#ffffff" />
              </div>
              <span>Jobs</span>
              <div className="expand-icon">
                {jobsExpanded ? (
                  <ChevronDown size={16} />
                ) : (
                  <ChevronRight size={16} />
                )}
              </div>
            </div>

            {jobsExpanded && (
              <motion.div
                className="sidebar-item-li"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.2 }}
              >
                {[
                  {
                    label: "Open Jobs",
                    link: "/locum/open-jobs",
                    id: 1,
                    fn: trackOpenJob,
                  },
                  {
                    label: "Accepted Jobs",
                    link: "/locum/accepted-jobs",
                    id: 2,
                    fn: trackAcceptedJob,
                  },
                  {
                    label: "Ongoing Jobs",
                    link: "/locum/ongoing-jobs",
                    id: 3,
                    fn: trackOngoingJob,
                  },
                  {
                    label: "Completed Jobs",
                    link: "/locum/completed-jobs",
                    id: 4,
                    fn: trackCompletedJob,
                  },
                  {
                    label: "Cancelled Jobs",
                    link: "/locum/cancelled-jobs",
                    id: 5,
                    fn: trackCancelledJob,
                  },
                  {
                    label: "Shift Logs",
                    link: "/locum/shift-logs",
                    id: 6,
                    fn: trackShiftlogJob,
                  },
                ].map(({ label, link, id, fn }, index) => (
                  <Link to={link} key={id}>
                    <img
                      src={dropdownStick}
                      className={`dropdownStick-${index + 1}`}
                    />
                    <li
                      className={locumActive === id ? "li-active" : ""}
                      onClick={() => {
                        if (onClose) onClose();
                        HandleLocumJobActiveTab(null, id);
                        fn && fn();
                      }}
                    >
                      {label}
                    </li>
                  </Link>
                ))}

                <div
                  onClick={() => {
                    handleLocumReportToggle();
                  }}
                >
                  <img src={dropdownStick} className="dropdownStick-7" />
                  <li
                    className={LocumReportToggle ? "li-active" : ""}
                    id="reports"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Reports</span>
                    {LocumReportToggle ? (
                      <ChevronDown size={16} color="#fff" />
                    ) : (
                      <ChevronRight size={16} color="#fff" />
                    )}
                  </li>
                </div>
              </motion.div>
            )}

            {LocumReportToggle && (
              <div className="sidebar-report-item-li">
                <Link to="/locum/open-jobs-report">
                  <img
                    src={dropdownStick}
                    className="dropdownStick-report-one"
                  />
                  <li
                    className={locumReportActive === 1 ? "li-active" : ""}
                    onClick={() => {
                      pushEvent("Web_OpenJob_Report", {
                        page: "Sidebar",
                        section: "Jobs",
                      });
                      handleLocumReportActive(1);
                      if (onClose) onClose();
                    }}
                  >
                    Open Jobs
                  </li>
                </Link>
                <Link to="/locum/accepted-jobs-report">
                  <img
                    src={dropdownStick}
                    className="dropdownStick-report-two"
                  />
                  <li
                    className={locumReportActive === 2 ? "li-active" : ""}
                    onClick={() => {
                      pushEvent("Web_AcceptedJob_Report", {
                        page: "Sidebar",
                        section: "Jobs",
                      });
                      handleLocumReportActive(2);
                      if (onClose) onClose();
                    }}
                  >
                    Accepted Jobs
                  </li>
                </Link>
                <Link to="/locum/ongoing-jobs-report">
                  <img
                    src={dropdownStick}
                    className="dropdownStick-report-three"
                  />
                  <li
                    className={locumReportActive === 3 ? "li-active" : ""}
                    onClick={() => {
                      pushEvent("Web_OngoingJob_Report", {
                        page: "Sidebar",
                        section: "Jobs",
                      });
                      handleLocumReportActive(3);
                      if (onClose) onClose();
                    }}
                  >
                    Ongoing Jobs
                  </li>
                </Link>
                <Link to="/locum/completed-jobs-report">
                  <img
                    src={dropdownStick}
                    className="dropdownStick-report-four"
                  />
                  <li
                    className={locumReportActive === 4 ? "li-active" : ""}
                    onClick={() => {
                      pushEvent("Web_CompletedJob_Report", {
                        page: "Sidebar",
                        section: "Jobs",
                      });
                      handleLocumReportActive(4);
                      if (onClose) onClose();
                    }}
                  >
                    Completed Jobs
                  </li>
                </Link>
                <Link to="/locum/cancelled-jobs-report">
                  <img
                    src={dropdownStick}
                    className="dropdownStick-report-five"
                  />
                  <li
                    className={locumReportActive === 5 ? "li-active" : ""}
                    onClick={() => {
                      pushEvent("Web_CancelledJob_Report", {
                        page: "Sidebar",
                        section: "Jobs",
                      });
                      handleLocumReportActive(5);
                      if (onClose) onClose();
                    }}
                  >
                    Cancelled Jobs
                  </li>
                </Link>
              </div>
            )}

            <div
              // className="menu-item"
              className={`menu-item ${usersExpanded ? "active" : ""}`}
              onClick={() => setUsersExpanded(!usersExpanded)}
            >
              <div className="icon-wrapper">
                <Users size={16} />
              </div>
              <span>Users</span>
              <div className="expand-icon">
                {usersExpanded ? (
                  <ChevronDown size={16} />
                ) : (
                  <ChevronRight size={16} />
                )}
              </div>
            </div>

            {usersExpanded && (
              <motion.div
                className="sidebar-item-li"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.2 }}
              >
                <div
                  className="sidebar-item-li"
                  style={{ marginLeft: "-20px" }}
                >
                  {/* Adjust marginLeft to align with the icon */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginLeft: "-50px",
                      gap: "8px",
                      overflow: "hidden",
                      marginTop: "-15px",
                    }}
                  >
                    <Link
                      to="/user/user-list"
                      // style={{ marginTop: "-15px", marginLeft: "-60px" }}
                    >
                      <img src={dropdownStick} className="dropdownStick-one" />
                      <li
                        className={userActive === 1 ? "li-active" : ""}
                        onClick={() => {
                          setUserActive(1);
                          if (onClose) onClose();
                        }}
                      >
                        User List
                      </li>
                    </Link>
                    <Link to="/user/permission" style={{ marginLeft: "20px" }}>
                      <img src={dropdownStick} className="dropdownStick-two" />
                      <li
                        className={userActive === 2 ? "li-active" : ""}
                        onClick={() => {
                          setUserActive(2);
                          if (onClose) onClose();
                        }}
                      >
                        Permissions
                      </li>
                    </Link>
                  </div>
                </div>
              </motion.div>
            )}

            {/* <div className="menu-item">
              <div className="icon-wrapper">
                <TrendingUp size={16} />
              </div>
              <span>Analytics</span>
            </div> */}

            <Link to={postingJob ? "/locum-job" : "/billing"}>
              <div
                // className="menu-item"
                className={`menu-item ${
                  location.pathname === "/billing" ? "active" : ""
                }`}
                onClick={() => {
                  pushEvent("Web_Billing", {
                    page: "Sidebar",
                    section: "Jobs",
                  });
                  if (onClose) onClose();
                  postingJob ? setDisacardPostingJob(true) : handleChange(6);
                }}
              >
                <div className="icon-wrapper">
                  <CreditCard size={16} />
                </div>
                <span>Billing</span>
              </div>
            </Link>

            <div className="shift-overview">
              <h3>Jobs Overview</h3>
              <div className="overview-item">
                <span>Upcoming Jobs (This Week)</span>
                <span className="count blue">
                  {locumHoursData?.upcomingJobsThisWeekCount
                    ? locumHoursData?.upcomingJobsThisWeekCount
                    : upcomingJobs}
                </span>
              </div>
              <div className="overview-item">
                <span>Open Jobs</span>
                <span className="count yellow">
                  {locumHoursData?.openJobsCount
                    ? locumHoursData?.openJobsCount
                    : openJobs}
                </span>
              </div>
              <div className="overview-item">
                <span>Completed Jobs</span>
                <span className="count green">
                  {" "}
                  {locumHoursData?.completedJobsCount
                    ? locumHoursData?.completedJobsCount
                    : completedJobs}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="sidebar-footer">
          <div className="profile-card">
            <div className="profile-left">
              <div className="avatar-circle">
                <img
                  src={userData?.userDetails?.avatar?.url || user}
                  alt="dp"
                />
              </div>
              <div className="user-details">
                <p className="name">{userData?.userDetails?.name?.full}</p>
                {/* <p className="name">Divya</p> */}
                {/* <p className="role">System Administrator</p> */}
              </div>
            </div>
            <div
              className="profile-settings"
              onClick={() => setShowDropdown(!showDropdown)}
              ref={dropdownRef}
            >
              <Settings size={18} />

              {showDropdown && (
                <div
                  className="settings-modal-inside"
                  // onClick={(e) => e.stopPropagation()}
                  onClick={() => setShowDropdown(false)}
                >
                  <h3>Settings</h3>

                  <div className="ms-row" onClick={() => {if (onClose) onClose(); navigateToProfile()}}>
                    <img src={profileIcon} className="ms-icon" />
                    <span className="ms-label">Profile Settings</span>
                  </div>

                  <div className="ms-row" onClick={handleWriteToUsClick}>
                    <img src={commentIcon} className="ms-icon" />
                    <span className="ms-label">Write To Us</span>
                  </div>

                  <div
                    className="ms-row"
                    onClick={() => {
                      setIsLogoutConfirmationOpen(true);
                      setIsSidebarOpen(!isSidebarOpen);
                      setShowDropdown(false);
                    }}
                  >
                    <img src={signOut} className="ms-icon" />
                    <span className="signout">Log out</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={isLogoutConfirmationOpen}
        onClose={() => setIsLogoutConfirmationOpen(!isLogoutConfirmationOpen)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <LogoutConfirmation
          setIsLogoutConfirmationOpen={setIsLogoutConfirmationOpen}
          handleLogout={handleLogout}
        />
      </Modal>
      <Modal
        open={showQueryModal}
        onClose={() => setShowQueryModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <JobShiftPostDetails
          handleCloseDetail={handleCloseDetail}
          setShowQueryModal={setShowQueryModal}
          showQueryModal={showQueryModal}
          selectedData={selectedData}
          // fetchShiftLogs={fetchShiftLogs}
        />
      </Modal>

      <Modal
        open={discardPostingJob}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <PostingJobModal
          setDiscardPostingJob={setDisacardPostingJob}
          setPostingJob={setPostingJob}
          dispatch={dispatch}
          setModel={setModel}
        />
      </Modal>
    </div>
  );
}

export default SidebarNew;
